import { NgModule } from '@angular/core';
import { LottieAnimationPlayerModule } from '@stantec/basin/lottie-animation-player';
import player from 'lottie-web';
import { PredictorPageComponent } from './pages/predictor-page/predictor-page.component';
import { AddFilesSectionComponent } from './components/add-files-section/add-files-section.component';
import { AgentSettingsSectionComponent } from './components/agent-settings-section/agent-settings-section.component';
import { ExportSectionComponent } from './components/export-section/export-section.component';
import { AccordionModule } from 'primeng/accordion';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { AccordionColumnComponent } from './components/accordion-column/accordion-column.component';
import { PredictorRoutingModule } from './predictor-routing.module';
import { PredictorButtonBarComponent } from './components/predictor-button-bar/predictor-button-bar.component';
import { CommonModule } from '@angular/common';
import { DialogService } from 'primeng/dynamicdialog';
import { DebrisFlowMapComponent } from '../global/components/debris-flow-map/debris-flow-map.component';
import { MapDetailModalComponent } from './components/map-detail-modal/map-detail-modal.component';
import { CardModule } from 'primeng/card';
import { SplitButtonModule } from 'primeng/splitbutton';
import { CircledIconModule } from '@stantec/basin/circled-icon';
import { OverlayCardComponent } from '../global/components/overlay-card/overlay-card.component';
import { UtmZoneModalComponent } from './components/utm-zone-modal/utm-zone-modal.component';
import { LoopModalComponent } from './components/loop-modal/loop-modal.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { FocusNextWrapperComponent } from './components/focus-next-wrapper/focus-next-wrapper.component';
import { AppColumnModule } from '@stantec/basin/app-column';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng'
import { BasinFormlyConfig } from '@stantec/basin/basin-formly';
import { InactivityModalComponent } from './components/inactivity-modal/inactivity-modal.component';
import { ListItemModule } from '@stantec/basin/list-item';
import { TagModule } from '@stantec/basin/tag';
import { StudyAreaListItemComponent } from './components/study-area-list-item/study-area-list-item.component';
import { StudyAreaDetailsComponent } from './components/study-area-details/study-area-details.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { SimulationLoopDetailsComponent } from './components/simulation-loop-details/simulation-loop-details.component';
import { SimulationDetailsComponent } from './components/simulation-details/simulation-details.component';
import { TerrainStatusComponent } from './components/terrain-status/terrain-status.component';
import { DetailFieldComponent } from './components/detail-field/detail-field.component';
import { DataViewModule } from 'primeng/dataview';
import { CheckboxModule } from 'primeng/checkbox';
import { PaintInfoModalComponent } from './components/paint-info-modal/paint-info-modal.component';
import { SimulationTrackerComponent } from './components/simulation-tracker/simulation-tracker.component';
import { TableModule } from 'primeng/table';
import { SearchboxModule } from '@stantec/basin/searchbox';
import { PullDownContainerModule } from '@stantec/basin/pull-down-container';
import { SimulationDetailsOverlayComponent } from './components/simulation-details-overlay/simulation-details-overlay.component';
import { WelcomeCardComponent } from './components/welcome-card/welcome-card.component';
import { StudyAreaStatusMessageComponent } from './components/study-area-status-message/study-area-status-message.component';
import { BooleanIconModule } from '@stantec/basin/boolean-icon';
import { SimulationsPageComponent } from './pages/simulations-page/simulations-page.component';
import { SimulationTrackerTableComponent } from './components/simulation-tracker-table/simulation-tracker-table.component';
import { DialogModule } from 'primeng/dialog';
import { PaginatorModule } from 'primeng/paginator';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { StudyAreaPaidModalComponent } from './components/study-area-paid-modal/study-area-paid-modal.component';
import { SimulationWarningModalComponent } from './components/simulation-warning-modal/simulation-warning-modal.component';
import { StudyAreaCommentModalComponent } from './components/study-area-comment-modal/study-area-comment-modal.component';
import { SimulationResultPageComponent } from './pages/simulation-result-page/simulation-result-page.component';
import { MenuModule } from 'primeng/menu';
import { TableUnsortModule } from '@stantec/basin/core';
import { BackgroundSimulationDetailsOverlayComponent } from './components/background-simulation-details-overlay/background-simulation-details-overlay.component';
import { StayOrLeaveStudyAreaModalComponent } from './components/stay-or-leave-study-area-modal/stay-or-leave-study-area-modal.component';
import { AgentSettingsListComponent } from './components/agent-settings-list/agent-settings-list.component';
import { SimulationTrackerDetailsComponent } from './components/simulation-tracker-details/simulation-tracker-details.component';
import { SimulationTrackerDetailsListComponent } from './components/simulation-tracker-details-list/simulation-tracker-details-list.component';
import { SimulationTrackerResultColumnComponent } from './components/simulation-tracker-result-column/simulation-tracker-result-column.component';
import { SimulationTrackerReportPageComponent } from './pages/simulation-tracker-report-page/simulation-tracker-report-page.component';
import { FishnetBatchDecisionModalComponent } from './components/fishnet-batch-decision-modal/fishnet-batch-decision-modal.component';
import { SimulationProgressModalComponent } from './components/simulation-progress-modal/simulation-progress-modal.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ToastModule } from 'primeng/toast';
import { TextboxWithUnitsModule } from '@stantec/basin/textbox-with-units';
import { ToggleDfpspecialistModalComponent } from './components/toggle-dfpspecialist-modal/toggle-dfpspecialist-modal.component';
import { SimulationBulkExportComponent } from './components/simulation-bulk-export/simulation-bulk-export.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { CommonSharedModule } from '../predictor-enterprise-license/shared/shared.module';
// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    DebrisFlowMapComponent,
    PredictorPageComponent,
    AccordionColumnComponent,
    AddFilesSectionComponent,
    AgentSettingsSectionComponent,
    ExportSectionComponent,
    PredictorButtonBarComponent,
    MapDetailModalComponent,
    OverlayCardComponent,
    UtmZoneModalComponent,
    LoopModalComponent,
    FocusNextWrapperComponent,
    InactivityModalComponent,
    StudyAreaListItemComponent,
    StudyAreaDetailsComponent,
    TerrainStatusComponent,
    SimulationLoopDetailsComponent,
    SimulationDetailsComponent,
    DetailFieldComponent,
    PaintInfoModalComponent,
    SimulationTrackerComponent,
    SimulationDetailsOverlayComponent,
    WelcomeCardComponent,
    StudyAreaStatusMessageComponent,
    SimulationsPageComponent,
    SimulationTrackerTableComponent,
    StudyAreaPaidModalComponent,
    SimulationWarningModalComponent,
    StudyAreaCommentModalComponent,
    SimulationResultPageComponent,
    BackgroundSimulationDetailsOverlayComponent,
    StayOrLeaveStudyAreaModalComponent,
    AgentSettingsListComponent,
    SimulationTrackerDetailsComponent,
    SimulationTrackerDetailsListComponent,
    SimulationTrackerResultColumnComponent,
    SimulationTrackerReportPageComponent,
    FishnetBatchDecisionModalComponent,
    SimulationProgressModalComponent,
    ToggleDfpspecialistModalComponent,
    SimulationBulkExportComponent
  ],
  imports: [
    LottieAnimationPlayerModule,
    TextboxWithUnitsModule,
    CommonModule,
    AccordionModule,
    DividerModule,
    DialogModule,
    ButtonModule,
    DropdownModule,
    FormsModule,
    ReactiveFormsModule,
    ListItemModule,
    TableModule,
    MenuModule,
    SearchboxModule,
    ProgressSpinnerModule,
    TagModule,
    TableUnsortModule,
    BooleanIconModule,
    FormlyPrimeNGModule,
    InputSwitchModule,
    ToastModule,
    MultiSelectModule,    
    FormlyModule.forRoot({
      types: BasinFormlyConfig.types,
      validationMessages: [
        ...BasinFormlyConfig.validationMessages,
        { name: 'maxLength', message: 'Max length 150 characters.' },
        {
          name: 'loop',
          message: (error, field: FormlyFieldConfig) => {
            const { max } = field.props as any;
            if (
              max !== undefined &&
              field.formControl &&
              field.formControl.value > max
            ) {
              return `A maximum of ${max} iterations can be performed.`;
            }
            return '';
          },
        },
        {
          name: 'startScenario',
          message: 'Start scenario must be less than or equal to end scenario.',
        },
        {
          name: 'endScenario',
          message:
            'End scenario must be greater than or equal to start scenario.',
        },

        {
          name: 'maxTextLength',
          message: (error, field: FormlyFieldConfig) => {
            const maxLength = (field.props)?.max;
            return `Maximum length ${maxLength} characters.`;
          },
        },
      ],
      wrappers: [
        ...BasinFormlyConfig.wrappers,
        { name: 'focus-next-wrapper', component: FocusNextWrapperComponent },
      ],
    }),
    PredictorRoutingModule,
    CardModule,
    CircledIconModule,
    DropdownModule,
    ConfirmDialogModule,
    SplitButtonModule,
    AppColumnModule,
    ProgressBarModule,
    DataViewModule,
    CheckboxModule,
    PullDownContainerModule,
    PaginatorModule,
    RadioButtonModule,
    CommonSharedModule,
  ],
  providers: [DialogService, ConfirmationService],
  exports: [PredictorPageComponent],

})
export class PredictorModule { }
